import React, { useEffect } from 'react';
import PropTypes from 'prop-types';

import AccountLocations from "./AccountLocations";

function Locations(props) {
	let {updateHeader, resetHeader, showSnackbar, banner, bannerHeight, setFullScreenClassName} = props;

	useEffect(() => {
		updateHeader({title: "locations", primary: true});
		return () => resetHeader();
	}, [updateHeader, resetHeader]);

	return (
		<AccountLocations
			{...props}
			updateHeader={updateHeader}
			resetHeader={resetHeader}
			showSnackbar={showSnackbar}
			banner={banner}
			bannerHeight={bannerHeight}
			setFullScreenClassName={setFullScreenClassName} />
	);
}

Locations.propTypes = {
	updateHeader: PropTypes.func.isRequired,
	resetHeader: PropTypes.func.isRequired,
	showSnackbar: PropTypes.func.isRequired,
	banner: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
	bannerHeight: PropTypes.number,
	setFullScreenClassName: PropTypes.func
};

export default Locations;